import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {interval, Subscription} from 'rxjs';
import {Card} from '../../../card-container/card/card';
import {UserService} from '../../../../../shared-components/user/user.service';
import {StudentService} from '../../../../../shared-components/student/student.service';
import {StudentSummaryService} from '../../../student-summary.service';
import {YearService} from '../../../../../shared-components/year/year.service';
import {CardStudentTeams} from './card-student-teams';
import {Router} from '@angular/router';

@Component({
    selector: 'app-student-teams-card',
    templateUrl: './student-teams-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./student-teams-card.component.css']
})
export class StudentTeamsCardComponent implements OnInit, OnDestroy {

    @Input() data: any;
    subscriptions: Subscription[] = [];
    card: Card;
    studentTeams: CardStudentTeams[] = [];
    // Angular Material Table
    displayedColumns: string[] = ['team', 'staffName', 'entry', 'exit'];

    constructor(
        private cdr: ChangeDetectorRef,
        private studentService: StudentService,
        private router: Router,
        private userService: UserService,
        private studentSummaryService: StudentSummaryService,
        private yearService: YearService
    ) {
    }

    ngOnInit() {
        this.card = this.data;
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getTeams();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    getTeams() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardStudentTeams(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier).subscribe((response) => {
            if (response.ok) {
                this.studentTeams = response.body;
                // Because we are using onPush change detection we need to update the view
                this.updateView();
            }
        });
    }

    viewStudentTeams() {
        this.router.navigateByUrl('/student360/teams?studentPortal=true');
    }

    updateView() {
        this.cdr.detectChanges();
    }
}
